import React, { useState, useRef, useMemo, useEffect } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import cx from 'classnames';
import styles from './index.module.scss.js';

const ScrollbarWrapper = ({
  scrollbarsOff,
  autoHeight,
  height,
  autoHeightMin,
  autoHeightMax,
  noHScrollTop,
  style,
  className,
  children,
  withShadow = false
}) => {
  const [canHorizontalScroll, setCanHorizontalScroll] = useState(false);
  const [canVerticalScroll, setCanVerticalScroll] = useState(false);
  const scrollWrapperRef = useRef(null);
  const memoHeight = useMemo(
    () => autoHeight ? "auto" : height || 580,
    [height, autoHeight]
  );
  const initScroll = () => {
    if (scrollbarsOff) return;
    if (!scrollWrapperRef?.current) return;
    setCanHorizontalScroll(
      scrollWrapperRef.current.getClientWidth() < scrollWrapperRef.current.getScrollWidth()
    );
    setCanVerticalScroll(
      scrollWrapperRef.current.getClientHeight() < scrollWrapperRef.current.getScrollHeight()
    );
  };
  useEffect(() => {
    initScroll();
  }, [scrollWrapperRef, scrollbarsOff, children, memoHeight]);
  useEffect(() => {
    window.addEventListener("resize", initScroll);
    return () => {
      window.removeEventListener("resize", initScroll);
    };
  }, []);
  return /* @__PURE__ */ React.createElement(
    Scrollbars,
    {
      renderTrackHorizontal: (props) => /* @__PURE__ */ React.createElement(
        "div",
        {
          ...props,
          className: cx(styles.scroll__track, props.className, {
            [styles["can-scroll"]]: canHorizontalScroll
          })
        }
      ),
      renderTrackVertical: (props) => /* @__PURE__ */ React.createElement(
        "div",
        {
          ...props,
          className: cx(styles.scroll__vertical, props.className, {
            [styles["can-scroll"]]: canVerticalScroll
          })
        }
      ),
      style: {
        ...style,
        width: "100%",
        height: memoHeight
      },
      className: cx(styles.scroll, className, "scroll-wrapper", {
        [styles["can-h-scroll"]]: canHorizontalScroll,
        [styles["can-v-scroll"]]: canVerticalScroll,
        [styles["with-shadow"]]: withShadow,
        [styles["no-h-top"]]: noHScrollTop
      }),
      autoHeight,
      autoHeightMin,
      autoHeightMax,
      ref: scrollWrapperRef
    },
    children
  );
};

export { ScrollbarWrapper as default };
//# sourceMappingURL=index.js.map
